/**
 * Formats a list of member and access perks or stats into a bullet-separated string.
 * @param {string[]} items
 * @param {string} separator
 * @returns {string}
 */
export const formatCommunityMetaText = (items = [], separator = " · ") => {
  return items.filter(Boolean).join(separator);
};
